export const iconPositions = {
    LEFT: 'left',
    RIGHT: 'right',
};
